import { useState } from "react";
import useStyles from "../styles";
import { Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

const CommentForm = ({
  handleSubmit,
  submitLabel,
  hasCancelButton = false,
  handleCancel,
  initialText = "",
}) => {
  const classes = useStyles();
  const [text, setText] = useState(initialText);
  const isTextareaDisabled = text.length === 0;
  const onSubmit = (event) => {
    event.preventDefault();
    handleSubmit(text);
    setText("");
  };
  return (
    <form onSubmit={onSubmit}>
      <Box sx={{ m: 1}}>
        <TextField
          multiline
          rows={6}
          className={classes.commentFormTextarea}
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      </Box>
      <Box sx={{ m: 1 }}>
        <Button
          type="submit"
          variant={'outlined'}
          disabled={isTextareaDisabled}
        >
          {submitLabel}
        </Button>
        {hasCancelButton && (
          <Button
            onClick={handleCancel}
          >
            Cancel
          </Button>
        )}
      </Box>
    </form>
  );
};

export default CommentForm;
